// extracted by css-extract-rspack-plugin
export default {"SwitchWrapper":"SwitchWrapper-oAJPWP","switchWrapper":"SwitchWrapper-oAJPWP","Label":"Label-D4y0Em","label":"Label-D4y0Em"};